import { IconButton, LaravelResponse, useBulkEdit, useOpen } from "@dgs/core";
import { AxiosResponse } from "axios";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router";
import { EditEventUserResponsibilityRequest } from "../../types/user";
import { EditEventUserResponsibilityDrawer } from "./EditEventUserResponsibilityDrawer";

interface Props {
	reloadList: () => void;
	editUserResponsibility: (values: EditEventUserResponsibilityRequest) => Promise<AxiosResponse<LaravelResponse<void>>>;
}

export const BulkEditEventUserResponsibilityAction: FC<Props> = ({ reloadList, editUserResponsibility }) => {
	const { t } = useTranslation();
	const { open, handleClose, handleOpen } = useOpen();
	const { selectedRows } = useBulkEdit();
	const { eventId = "" } = useParams<"eventId">();

	return (
		<>
			<IconButton
				disabled={selectedRows !== "all" && !selectedRows.length}
				title={t("Edit user responsibilities")}
				onClick={handleOpen}
				size="small"
				icon="edit"
			/>
			<EditEventUserResponsibilityDrawer
				open={open}
				handleClose={handleClose}
				selectedRows={selectedRows}
				reloadList={reloadList}
				editUserResponsibility={editUserResponsibility}
				eventId={eventId}
			/>
		</>
	);
};
